import React, { useEffect, useRef, useState } from "react"
import mobiscroll from '@mobiscroll/react'
import * as m5 from '@mobiscroll/react5'
import dealersOptions from '../dataset/dealers.json'

const DealerEditor = ({ dealer, onCancel, onSet }) => {
    const creditRef = useRef(null);
    const [nameErrMsg, setNameErrMsg] = useState('')
    const [dcErrMsg, setDcErrMsg] = useState('')
    const [mfrErrMsg, setMfrErrMsg] = useState('')
    const [mfErrMsg, setMfErrMsg] = useState('')
    const [mtrErrMsg, setMtrErrMsg] = useState('')
    const [ssrErrMsg, setSsrErrMsg] = useState('')
    const [bsfErrMsg, setBsfErrMsg] = useState('')
    const [displayCredit, setDisplayCredit] = useState(false)

    useEffect(() => {
        if (dealer) {
            setDisplayCredit(dealer.mtr && dealer.ssr && dealer.bsf)
        }

    }, [dealer])

    const dcPopupBtns = [
        {
            text: '取消',
            cssClass: 'float-left',
            handler: onCancel
        },
        {
            text: '確定',
            handler: () => {
                let isOkay = true
                let name = document.getElementById("select-dealer-name").value
                if (name.length > 1 && name.length <= 6) {
                    setNameErrMsg('')
                } else {
                    isOkay = false
                    setNameErrMsg('字數介於2~6')
                }
                let dc = parseFloat(document.getElementById("select-dealer-discount").value)
                if (dc <= 1 && dc > 0) {
                    setDcErrMsg('')
                } else {
                    isOkay = false
                    setDcErrMsg('應介於0~1')
                }
                let mfr = parseInt(document.getElementById("select-dealer-minFeeR").value)
                if (mfr <= 20 && mfr > 0) {
                    setMfrErrMsg('')
                } else {
                    isOkay = false
                    setMfrErrMsg('應介於1~20元')
                }
                let mf = parseInt(document.getElementById("select-dealer-minFee").value)
                if (mf <= 20 && mf > 0) {
                    setMfErrMsg('')
                } else {
                    isOkay = false
                    setMfErrMsg('應介於1~20元')
                }
                let mtr = ''
                let ssr = ''
                let bsf = ''
                if (displayCredit) {
                    mtr = parseFloat(document.getElementById("select-dealer-mtr").value)
                    if (mtr < 100 && mtr > 0) {
                        setMtrErrMsg('')
                    } else {
                        isOkay = false
                        setMtrErrMsg('請設定合理利率')
                    }
                    ssr = parseFloat(document.getElementById("select-dealer-ssr").value)
                    if (ssr < 100 && ssr > 0) {
                        setSsrErrMsg('')
                    } else {
                        isOkay = false
                        setSsrErrMsg('請設定合理利率')
                    }
                    bsf = parseFloat(document.getElementById("select-dealer-bsf").value)
                    if (bsf < 100 && bsf > 0) {
                        setBsfErrMsg('')
                    } else {
                        isOkay = false
                        setBsfErrMsg('請設定合理費率')
                    }
                }

                if (isOkay) {
                    let newDealer = {
                        id: dealer.id,
                        name,
                        dc,
                        mfr,
                        mf,
                        mtr,
                        ssr,
                        bsf
                    }
                    onSet(newDealer)
                }
            }
        }
    ]

    const enableCredit = ev => {
        setDisplayCredit(ev.target.checked)
        if (!ev.target.checked) {
            onSet({ ...dealer, mtr: '', ssr: '', bsf: '' }, true)
        }
    }

    //console.log(dealersOptions)
    if (dealer && !dealer.name) {
        dealer.name = dealersOptions.filter(o => (o.id === dealer.id))[0].name
    }

    return (
        <m5.Popup isOpen={dealer !== null} buttons={dcPopupBtns}>
            {dealer &&
                <>
                    <h6>券商名稱</h6>
                    <m5.Input inputStyle="box" id="select-dealer-name" type="text" placeholder="ex:小孩帳戶" disabled={dealer.id.indexOf('sb') === -1}
                        error={nameErrMsg !== ''} errorMessage={nameErrMsg} defaultValue={dealer.name.replace('自訂', '') || ''}></m5.Input>
                    <h6>手續費折數</h6>
                    <m5.Input inputStyle="box" id="select-dealer-discount" type="number" placeholder="ex:6折 請填0.6"
                        error={dcErrMsg !== ''} errorMessage={dcErrMsg} defaultValue={dealer.dc || ''}></m5.Input>
                    <h6>零股最低手續費</h6>
                    <m5.Input inputStyle="box" id="select-dealer-minFeeR" type="number" placeholder="1~20"
                        error={mfrErrMsg !== ''} errorMessage={mfrErrMsg} defaultValue={dealer.mfr || ''}></m5.Input>
                    <h6>整股最低手續費（少部分券商適用）</h6>
                    <m5.Input inputStyle="box" id="select-dealer-minFee" type="number" placeholder="1~20"
                        error={mfErrMsg !== ''} errorMessage={mfErrMsg} defaultValue={dealer.mf || 20}></m5.Input>
                    <mobiscroll.Switch ref={creditRef} inputStyle="box" className="mx-2 bg-transparent"
                        defaultChecked={dealer.mtr && dealer.ssr && dealer.bsf} onChange={enableCredit}>
                        啟用信用交易
                    </mobiscroll.Switch>
                    {displayCredit && <>
                        <h6>融資利率(%)</h6>
                        <m5.Input inputStyle="box" id="select-dealer-mtr" type="number" placeholder="一般介於 5~7"
                            error={mtrErrMsg !== ''} errorMessage={mtrErrMsg} defaultValue={dealer.mtr || ''} />
                        <h6>融券利率(%)</h6>
                        <m5.Input inputStyle="box" id="select-dealer-ssr" type="number" placeholder="一般介於 0.1~0.4"
                            error={ssrErrMsg !== ''} errorMessage={mtrErrMsg} defaultValue={dealer.ssr || ''} />
                        <h6>借券費(%)</h6>
                        <m5.Input inputStyle="box" id="select-dealer-bsf" type="number" placeholder="一般為 0.08"
                            error={bsfErrMsg !== ''} errorMessage={mtrErrMsg} defaultValue={dealer.bsf || ''} />
                    </>
                    }
                </>}
        </m5.Popup >
    )
}

export default DealerEditor